import { render, staticRenderFns } from "./ProfessorDeficientesCard.vue?vue&type=template&id=de379edc&scoped=true"
import script from "./ProfessorDeficientesCard.vue?vue&type=script&lang=js"
export * from "./ProfessorDeficientesCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorDeficientesCard.vue?vue&type=style&index=0&id=de379edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de379edc",
  null
  
)

export default component.exports